module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "centerc1"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITICAL")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERICA")])]), _vm._v(" "), _c('p', {
    staticClass: "centerc"
  }, [_vm._v("General Editors: R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICHARD")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELGADO")]), _vm._v(" and J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAN")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TEFANCIC")])]), _vm._v(" "), _c('p', {
    staticClass: "centerc"
  }, [_vm._v("White by Law:"), _c('br'), _vm._v("The Legal Construction of Race"), _c('br'), _vm._v("Ian Haney López")]), _vm._v(" "), _c('p', {
    staticClass: "centerc"
  }, [_vm._v("Cultivating Intelligence:"), _c('br'), _vm._v("Power, Law, and the Politics of Teaching"), _c('br'), _vm._v("Louise Harmon and Deborah W. Post")]), _vm._v(" "), _c('p', {
    staticClass: "centerc"
  }, [_vm._v("Privilege Revealed:"), _c('br'), _vm._v("How Invisible Preference Undermines America"), _c('br'), _vm._v("Stephanie M. Wildman"), _c('br'), _vm._v("with Margalynne Armstrong, Adrienne D. Davis, and Trina Grillo")]), _vm._v(" "), _c('p', {
    staticClass: "centerc"
  }, [_vm._v("Does the Law Morally Bind the Poor?"), _c('br'), _vm._v("or What Good’s the Constitution When You Can’t Afford a Loaf of Bread"), _c('br'), _vm._v("R. George Wright")]), _vm._v(" "), _c('p', {
    staticClass: "centerc"
  }, [_vm._v("Hybrid:"), _c('br'), _vm._v("Bisexuals, Multiracials, and Other Misfits under American Law"), _c('br'), _vm._v("Ruth Colker")]), _vm._v(" "), _c('p', {
    staticClass: "centerc"
  }, [_vm._v("Critical Race Feminism:"), _c('br'), _vm._v("A Reader"), _c('br'), _vm._v("Edited by Adrien Katherine Wing")]), _vm._v(" "), _c('p', {
    staticClass: "centerc"
  }, [_vm._v("Immigrants Out!"), _c('br'), _vm._v("The New Nativism and the Anti-Immigrant Impulse in the United States"), _c('br'), _vm._v("Edited by Juan F. Perea")]), _vm._v(" "), _c('p', {
    staticClass: "centerc"
  }, [_vm._v("Taxing America"), _c('br'), _vm._v("Edited by Karen B. Brown and Mary Louise Fellows")]), _vm._v(" "), _c('p', {
    staticClass: "centerc"
  }, [_vm._v("Notes of a Racial Caste Baby:"), _c('br'), _vm._v("Colorblindness and the End of Affirmative Action"), _c('br'), _vm._v("Bryan K. Fair")]), _vm._v(" "), _c('p', {
    staticClass: "centerc"
  }, [_vm._v("Please Don’t Wish Me a Merry Christmas:"), _c('br'), _vm._v("A Critical History of the Separation of Church and State"), _c('br'), _vm._v("Stephen M. Feldman")]), _vm._v(" "), _c('p', {
    staticClass: "centerc"
  }, [_vm._v("To Be an American:"), _c('br'), _vm._v("Cultural Pluralism and the Rhetoric of Assimilation"), _c('br'), _vm._v("Bill Ong Hing")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72723470","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm1.vue
// module id = 63
// module chunks = 0